/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_TitleInputs */

const tr_landing_pricerules_title = /** @type {(inputs: Landing_Pricerules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolar oynadığında,`)
};

const en_landing_pricerules_title = /** @type {(inputs: Landing_Pricerules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When the dollar moves,`)
};

const de_landing_pricerules_title = /** @type {(inputs: Landing_Pricerules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn der Dollar schwankt,`)
};

const ru_landing_pricerules_title = /** @type {(inputs: Landing_Pricerules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда доллар меняется,`)
};

/**
* | output |
* | --- |
* | "When the dollar moves," |
*
* @param {Landing_Pricerules_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_title = /** @type {((inputs?: Landing_Pricerules_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_title(inputs)
	if (locale === "de") return de_landing_pricerules_title(inputs)
	if (locale === "ru") return ru_landing_pricerules_title(inputs)
	return tr_landing_pricerules_title(inputs)
});